// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"994ef8b2","442":"d7056f5a","669":"072fe18f","687":"cdb3321d","750":"997848c3"}[chunkId] + ".chunk.js";
};